import React from 'react';
import logo from './logo.svg';
import './App.css';
import AppLayout from './appLayout';


function App() {
	return (
		<div className="App">
			<header className="App-header">
				<img src={logo} className="App-logo" alt="logo" />
				<p>
					Dev update 2
				</p>
				<AppLayout/>
			</header>
		</div>
	);
}

export default App;
